import { Button, Typography } from '@mui/material';
import { DialogContainerComponent } from '../../layout/dialogContainer.component';
import { SYNC_LOCATION_FAILURE, SYNC_LOCATION_SUCCESS, syncLocation } from '../location.actions';
import { handleToastMessage } from '../../layout/layout.actions';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

function SyncLocationDialog({ isOpen, onClose, onSubmit }) {
  return (
    <DialogContainerComponent
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      title="Are you sure you want to sync this location?"
      submitButtonText="Sync to Hubspot"
    >
      <Typography variant="subtitle1">
        Please confirm you want to sync<br />all properties of this location to hubspot.
      </Typography>
    </DialogContainerComponent>
  );
}

SyncLocationDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

function SyncLocation({ className, disabled, selectedLocation }) {
  const [isOpen, setIsOpen] = useState(false);
  const dialog = {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };
  const dispatch = useDispatch();
  const sync = async () => {
    const { type, messages } = await dispatch(syncLocation(selectedLocation.id));
    if (type === SYNC_LOCATION_SUCCESS) {
      dispatch(handleToastMessage('Location synced to hubspot'));
    } else if (type === SYNC_LOCATION_FAILURE) {
      let errorMessage = 'Failed to sync location';
      if (messages.length) {
        errorMessage = `${errorMessage}: ${messages.join(',')}`;
      }
      dispatch(handleToastMessage(errorMessage, true));
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        className={className}
        onClick={dialog.open}
        disabled={disabled}
      >
        Sync
      </Button>
      <SyncLocationDialog
        isOpen={dialog.isOpen}
        onClose={dialog.close}
        onSubmit={sync}
      />
    </>
  );
}

SyncLocation.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.Boolean,
  selectedLocation: PropTypes.object.isRequired,
};

export default withRouter(SyncLocation);